import { GiAmericanFootballPlayer } from 'react-icons/gi'

export default function Loading() {
	return (
		<div className="flex h-20 grow items-center justify-center">
			{/* <GiAmericanFootballPlayer className="fill-byuRoyal h-20 w-20 animate-spin border border-green-300 bg-gray-400 repeat-infinite" />
			<GiAmericanFootballPlayer className="fill-byuRoyal h-20 w-20 animate-ping border border-green-300 bg-gray-400 repeat-infinite" />
			<GiAmericanFootballPlayer className="fill-byuRoyal h-20 w-20 animate-pulse border border-green-300 bg-gray-400 repeat-infinite" /> */}
			<GiAmericanFootballPlayer className="fill-byuRoyal h-20 w-20 animate-bounce repeat-infinite" />
			<GiAmericanFootballPlayer className="fill-byuRoyal h-20 w-20 animate-bounce delay-150 repeat-infinite" />
			<GiAmericanFootballPlayer className="fill-byuRoyal h-20 w-20 animate-bounce delay-300 repeat-infinite" />
		</div>
	)
}
